import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { APP_INITIALIZER } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter } from "@angular/router";
import { AppComponent } from "./app/app.component";
import { APP_ROUTES } from "./app/app.routes";
import { authInterceptor } from "./app/core/interceptors/auth.interceptor";
import { httpClientInterceptor } from "./app/core/interceptors/httpclient.interceptor";
import { AuthService } from "./app/core/services/auth.service";

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (auth: AuthService) => () => auth.initializeSession(),
      deps: [AuthService],
    },
    provideHttpClient(
      withInterceptors([authInterceptor, httpClientInterceptor]),
    ),
  ],
}).catch((err) => console.error(err));
